import React from 'react';
import { Chessboard } from 'react-chessboard';
import { Chess } from 'chess.js';
import useSound from 'use-sound';
import moveSound from '../../sounds/Move.mp3';
import captureSound from '../../sounds/Capture.mp3';
import { DataContext } from '../DataProvider';
import { UserContext } from '../UserProvider';

import { updateLessonCompleteEndpoint, goToNextLesson } from '../../utils';

import styled from 'styled-components';

function ChessBoard({ quizId, exId }) {
  const [chess, setChess] = React.useState(new Chess());
  const [positionFen, setPositionFen] = React.useState(chess.fen());
  const [validateMove, setValidateMove] = React.useState(true);
  // const [selectedExerciseIndex, setSelectedExerciseIndex] = React.useState(0);
  // const [currPositionIndex, setCurrPositionIndex] = React.useState(0);
  const [playMoveSound] = useSound(moveSound);
  const [playCaptureSound] = useSound(captureSound);

  const {
    exerciseData,
    setExerciseData,
    selectedQuizId,
    selectedCourse,
    setSelectedVideoId,
    setSelectedEpisodeNumber,
    setSelectedQuizId,
    setApiWasRequested,
    setRequestWasHandled,
    setExerciseWasRequested,
    setExerciseWasFetched,
    lessons,
    setCourseProgress,
    selectedExerciseIndex,
    setSelectedExerciseIndex,
    currPositionIndex,
    setCurrPositionIndex,
  } = React.useContext(DataContext);
  const { token } = React.useContext(UserContext);

  const handleExerciseChange = (index) => {
    setCurrPositionIndex(0);
    setSelectedExerciseIndex(index);
  };

  // const resetPosition = (index) => {
  //   setCurrPositionIndex(0);
  // };

  if (!exerciseData) {
    return <LoadingSpan>Loading...</LoadingSpan>;
  }

  const numExercises = exerciseData.length;
  var selectedExercise = null;
  var currPosition = null;
  var orientation = null;
  if (exerciseData.length === 0) {
    return <LoadingSpan>"Loading..."</LoadingSpan>;
  }
  if (selectedExerciseIndex === numExercises) {
    setSelectedExerciseIndex(0);
    setCurrPositionIndex(0);
    setExerciseData(null);
    setTimeout(() => {
      var alreadyAdvancedSection = false;
      setCourseProgress((oldCourseProgress) => {
        const newCourseProgress = { ...oldCourseProgress };
        Object.keys(newCourseProgress).forEach((section) => {
          const updatedSection = newCourseProgress[section].map((lesson) => {
            if (
              lesson.episode_number &&
              lesson.episode_number === selectedQuizId
            ) {
              updateLessonCompleteEndpoint(
                selectedCourse,
                section,
                lesson.episode_number,
                'COMPLETE',
                token
              );
              if (!alreadyAdvancedSection) {
                goToNextLesson(
                  lessons,
                  lesson,
                  setSelectedVideoId,
                  setSelectedEpisodeNumber,
                  setSelectedQuizId,
                  setApiWasRequested,
                  setRequestWasHandled,
                  setExerciseWasRequested,
                  setExerciseWasFetched
                );
                alreadyAdvancedSection = true;
              }

              return { ...lesson, status: 'COMPLETE' };
            }
            return lesson;
          });
          newCourseProgress[section] = updatedSection;
        });
        return newCourseProgress;
      });
    }, 700);
    return <H1>Great Job!</H1>;
  }

  // console.log(`exerciseData=${JSON.stringify(exerciseData)}`);
  // console.log(`selectedExerciseIndex=${selectedExerciseIndex}`);

  selectedExercise = exerciseData[selectedExerciseIndex];
  console.log(`selectedExerciseIndex=${selectedExerciseIndex}`);
  const currData = JSON.parse(selectedExercise.DATA);
  const positions = currData.filter((item) => item.dataType === 'position');
  console.log(`positions=${JSON.stringify(positions)}`);
  var nextPosition = currPositionIndex;
  console.log(`currPositionIndex=${JSON.stringify(currPositionIndex)}`);

  if (currPositionIndex === positions.length) {
    nextPosition -= 1;
    setTimeout(() => {
      handleExerciseChange(selectedExerciseIndex + 1);
    }, 700);
  }

  if (currPositionIndex > positions.length) {
    nextPosition = 0;
  }
  currPosition = positions[nextPosition].fen;
  orientation = selectedExercise.ORIENTATION;
  chess.load(currPosition);
  const fenPlayerToMove = currPosition.split(' ')[1];
  if (fenPlayerToMove !== orientation) {
    if (currPositionIndex < positions.length) {
      setTimeout(() => {
        if (currPositionIndex < positions.length - 1) {
          playMoveSound();
        }
        setCurrPositionIndex((previous) => {
          return previous + 1;
        });
      }, 700);
    }
  }

  const orientationToUse = orientation
    ? orientation === 'b'
      ? 'black'
      : 'white'
    : 'white';

  const handlePieceDrop = (sourceSquare, targetSquare) => {
    try {
      if (validateMove) {
        const pieceType = chess.get(sourceSquare)?.type;
        const targetRank = targetSquare[1];
        const promotion =
          pieceType === 'p' && (targetRank === '1' || targetRank === '8')
            ? 'q'
            : undefined;
        let move = chess.move({
          from: sourceSquare,
          to: targetSquare,
          promotion: promotion,
        });

        if (move) {
          const nextFenPrefix = positions[currPositionIndex + 1].fen.slice(
            0,
            -4
          );
          const postMoveFenPrefix = chess.fen().slice(0, -4);
          const moveWasCorrect = postMoveFenPrefix === nextFenPrefix;
          console.log(`postMoveFenPrefix=${postMoveFenPrefix}`);
          console.log(`nextFenPrefix=${nextFenPrefix}`);
          console.log(`moveWasCorrect=${moveWasCorrect}`);

          if (moveWasCorrect) {
            setCurrPositionIndex((previous) => {
              return previous + 1;
            });
          }

          if (move.flags.includes('c')) {
            playCaptureSound();
          } else {
            playMoveSound();
          }

          //setPositionFen(chess.fen());
          return true;
        } else {
          return false;
        }
      } else {
        if (targetSquare) {
          setPositionFen((prevFen) => {
            const newChess = new Chess(prevFen);

            const pieceType = newChess.get(sourceSquare)?.type;
            const pieceColor = newChess.get(sourceSquare)?.color;

            if (pieceType && pieceColor) {
              newChess.remove(sourceSquare);
              newChess.put(
                { type: pieceType, color: pieceColor },
                targetSquare
              );
            }

            return newChess.fen();
          });
          return true;
        } else {
          setPositionFen((prevFen) => {
            const newChess = new Chess(prevFen);
            newChess.remove(sourceSquare);
            return newChess.fen();
          });
          return true;
        }
      }
    } catch (error) {
      //cslg ('Error making move:', error);
      return false;
    }
  };

  return (
    <Div>
      <Chessboard
        id='BasicBoard'
        onPieceDrop={handlePieceDrop}
        position={currPosition}
        dropOffBoardAction='trash'
        boardOrientation={orientationToUse}
        allowDragOutsideBoard={!validateMove}
        animationDuration={500}
      />
      {Array.from({ length: numExercises }, (_, i) => (
        <Button
          isSelected={selectedExerciseIndex === i}
          key={i}
          onClick={() => handleExerciseChange(i)}
        >
          {i + 1}
        </Button>
      ))}
      {/* <Button key='reset' onClick={resetPosition}>
        R
      </Button> */}
    </Div>
  );
}

export default ChessBoard;

const Div = styled.div`
  margin-left: 200px;
  /* margin-top: 100px; */
  width: 70%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`;

const Button = styled.button`
  padding: 3px 5px;
  color: white;
  width: max(10px, fit-content);
  margin-top: 10px;
  margin-right: 7px;
  border: ${({ isSelected }) => (isSelected ? '1px solid orange' : 'none')};
  border-radius: 2px;
`;

const H1 = styled.button`
  font-size: 48px;
  color: hsl(120, 86%, 54%);
`;

const LoadingSpan = styled.span`
  color: white;
`;
